import React from 'react'

import { confirmationColor } from '../../globalVar';
import { Button, Grid, Icon, Segment, Transition } from 'semantic-ui-react';
import { navigate } from 'gatsby';
import ImageHolder from '../ImageHolder';

import * as styles from './styles/addToCart.module.css'

const AddToCartPrompt = ({ promptVisible, product, handleHover, closePrompt }) => {
    return (
        <Transition.Group animation={"fade left"} duration={300}>
            {promptVisible &&
                <div
                    name="addToCartPrompt"
                    className={`${styles.addToCartPromptContainer}`}
                    onMouseEnter={handleHover !== undefined ? () => handleHover(true) : null}
                    onMouseLeave={handleHover !== undefined ? () => handleHover(false) : null}
                >
                    <Segment>
                        <Icon
                            name="close"
                            className={`${styles.closeButton}`}
                            onClick={closePrompt}
                        />
                        <Grid centered>
                            
                        </Grid>
                        <Grid centered verticalAlign='middle'>
                            <Grid.Column width={16} textAlign='center'>
                                Added to cart
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <ImageHolder
                                    heightToWidthRatio={1}
                                    src={product.image}
                                    displayMode="default"
                                />
                            </Grid.Column>
                            <Grid.Column width={4}>
                                <p>x{product.quantity}</p>
                            </Grid.Column>
                        </Grid>
                        <Grid verticalAlign='middle'>
                            <Grid.Column width={16}>
                                <p><span>{product.name}</span></p>
                                <Button
                                    fluid
                                    size="small"
                                    color={confirmationColor}
                                    onClick={() => {
                                        navigate("/cart/")
                                        closePrompt();
                                    }}
                                >
                                    Proceed to Checkout
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Segment>
                </div>
            }
        </Transition.Group>
    )
}

export default AddToCartPrompt